import React from "react";
import removeImg from "assets/svgs/close.svg";
import { v4 } from "uuid";
import { Col, Row } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import ImageUpdate from "./ImageUpdate";
import ClientImageUpdate from "./clientImageUpdate";

const SlidersArray = ({ sliders, setSliders }) => {
  const handleInputOnChange = (e, id) => {
    const { name, value } = e.target;

    const newSlidersArray = sliders?.map((slider, index) => {
      if (index !== id) return slider;

      // make an object with locals inside the big one
      const inputName = name?.split(".")?.[0];
      const local = name?.split(".")?.[1];

      if (local) {
        return {
          ...slider,
          [inputName]: {
            ...slider?.[inputName],
            [local]: value,
          },
        };
      }

      return { ...slider, [name]: value };
    });

    setSliders(newSlidersArray);
  };

  const removeSlider = (sliderId) => {
    const newSliders = sliders?.filter((slider, index) => index !== sliderId);
    setSliders(() => newSliders);
  };

  const addSlider = () => {
    setSliders(() => [
      ...(sliders || []),
      {
        client: {
          name: "",
          position: "",
          review: "",
        },
      },
    ]);
  };
  return (
    <div className="form-group branches sliders">
      <Row style={{ rowGap: "10px" }}>
        <h5>
          <FormattedMessage id={"reviews"} />
        </h5>

        {sliders?.map((slider, index) => {
          return (
            <Row key={index} className="">
              <div className="add-multi-component">
                <Row style={{ rowGap: "10px" }}>
                  <button
                    type="button"
                    onClick={() => removeSlider(index)}
                    className="removeImg"
                  >
                    <img src={removeImg} alt="" />
                  </button>
                  <Row>
                    <Col lg={6} className="text-center">
                      <ImageUpdate
                        index={index}
                        item={slider}
                        sliders={sliders}
                        setSliders={setSliders}
                      />
                    </Col>
                    <Col lg={6} className="text-center">
                      <ClientImageUpdate
                        index={index}
                        item={slider.client}
                        sliders={sliders}
                        setSliders={setSliders}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Row>
                      <Row>
                        <Col lg={6}>
                          <div className="form-group">
                            <h5>
                              <FormattedMessage id={"review"} />
                            </h5>
                            <input
                              type="review"
                              name={"client.review"}
                              className="form-control form-outline"
                              onChange={(e) => handleInputOnChange(e, index)}
                              value={slider?.client.review}
                            />
                          </div>
                        </Col>
                        <Col lg={6}>
                          <div className="form-group">
                            <h5>
                              <FormattedMessage id={"name"} />
                            </h5>
                            <input
                              type="name"
                              name={"client.name"}
                              className="form-control form-outline"
                              onChange={(e) => handleInputOnChange(e, index)}
                              value={slider?.client.name}
                            />
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <div className="form-group">
                          <h5>
                            <FormattedMessage id={"description"} />
                          </h5>
                          <input
                            type="title"
                            name={"client.position"}
                            className="form-control form-outline"
                            onChange={(e) => handleInputOnChange(e, index)}
                            value={slider?.client.position}
                          />
                        </div>
                      </Row>
                    </Row>
                  </Row>
                </Row>
              </div>
            </Row>
          );
        })}

        <Row>
          <Col lg={4} xs={12} className="text-left">
            <button
              type="button"
              className="btn btn-green add_new_section__"
              onClick={() => {
                addSlider();
              }}
            >
              <FormattedMessage id={"addReview"} />
            </button>
          </Col>
        </Row>
      </Row>
    </div>
  );
};

export default SlidersArray;
